'use strict';

var Field = require('./Field');

angular.module('dekky.forms.fields.collection', [])
.factory('CollectionField', function($log, $q) {
	function collectionFactory(name, options, childForm) {
		function Collection(name, options, childForm) {
			this.type = 'collection';

			if (!childForm) {
				throw new Exception('Undefined child form');
			}

			this.buttons = angular.merge({
				add: 'add',
				remove: 'remove',
				copy: 'copy'
			}, options.buttons);
			this.childForm = childForm;
			this.doDelete = function(item, model, index) {
				model.splice(index, 1);
			};
			this.ngRepeat = 'item in model track by $index';

			Field.apply(this, arguments);
		}

		Collection.prototype = Object.create(Field.prototype);
		Collection.prototype.addItem = function(model) {
			var newItem = {};

			Object.keys(this.childForm.$fields).forEach(function(key) {
				newItem[key] = undefined;
			});

			model.push(newItem);
		};

        Collection.prototype.copyItem = function(item, model, index) {
            var newItem = angular.copy(item);

            model.push(newItem);
        };

		Collection.prototype.link = function(template) {
			var collection = template[0].querySelector('[repeat-collection]');

			angular.element(collection).removeAttr('repeat-collection');
			angular.element(collection).attr('ng-repeat', this.ngRepeat);

			return $q.when(template);
		};

		return new Collection(name, options, childForm);
	}

	return collectionFactory;
});
